import React, { Component } from "react";
import { FormGroup } from "semantic-ui-react";
import { Button, Modal, ControlLabel, FormControl } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import _ from "lodash";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import Multiselect from "react-widgets/lib/Multiselect";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";

// Css
import "../../assets/css/groupmanagement.css";

// Image
import userIcon from "../../assets/img/groupmanagement/users_icon.png";
import lockIcon from "../../assets/img/groupmanagement/locks_icon.png";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    viewDetailsBtn: "View Details",
    groupProfileHeader: "Group Profile",
    membersTitle: "Members",
    locksTitle: "Locks",
    groupNameLabel: "Group Name :",
    groupDescriptionLabel: "Group Description :",
    // groupMembersLabel: "Group Members",
    groupMembersLabel: "Group Member List",
    nameHeader: "Name",
    emailHeader: "Email",
    noDataTitle: "There is no data to display",
  },
  ja: {
    viewDetailsBtn: "詳細",
    groupProfileHeader: "グループ名",
    membersTitle: "メンバー",
    locksTitle: "スマートロック",
    groupNameLabel: "グループ名",
    groupDescriptionLabel: "グループメモ",
    // groupMembersLabel: "Group Members",
    groupMembersLabel: "グループメンバーリスト",
    nameHeader: "名前",
    emailHeader: "Eメール",
    noDataTitle: "表示するデータがありません。",
  },
  es: {
    viewDetailsBtn: "Ver Detalles",
    groupProfileHeader: "Perfil del Grupo",
    membersTitle: "Miembros",
    locksTitle: "Candados",
    groupNameLabel: "Nombre del Grupo :",
    groupDescriptionLabel: "Descripción del Grupo :",
    groupMembersLabel: "Lista de Miembros del Grupo",
    nameHeader: "Nombre",
    emailHeader: "Correo Electrónico",
    noDataTitle: "No hay datos para mostrar",
  },
});

export class GroupProfile extends Component {
  constructor(props) {
    super(props);

    const cell = this.props.cellValue;
    const row = this.props.rowValue;

    var memberarray = [];
    _.map(row.groupMembers, (memberData) => {
      memberarray.push(memberData);
    });

    var lockarray = [];
    _.map(row.groupLocks, (lockData) => {
      lockarray.push(lockData);
    });

    this.state = {
      _notificationSystem: null,
      cell: cell,
      row: row,
      showPopup: false,
      groupID: row.groupID,
      groupName: row.groupName,
      groupDesc: row.groupDesc,
      selectedMember: memberarray,
      groupLocksArrayList: lockarray,
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
      groupLocksArrayList: lockarray, // existing
      sharedLocksCount: 0, // ✅ new
      isLoading: false,
      // memberemaillistArray: [],
      // groupmemberslistArray: [],
      // selectedMember: [],
      // groupNameExist: false,
      // groupsArrayList: [],
    };

    this.handleGroupProfilePopupOpen = this.handleGroupProfilePopupOpen.bind(
      this,
    );
    this.handleGroupProfilePopupClose = this.handleGroupProfilePopupClose.bind(
      this,
    );
  }

  componentWillReceiveProps(nextProps) {
    var memberarray = [];
    _.map(nextProps.rowValue.groupMembers, (memberData) => {
      memberarray.push(memberData);
    });

    var lockarray = [];
    _.map(nextProps.rowValue.groupLocks, (lockData) => {
      lockarray.push(lockData);
    });

    this.setState({
      cell: nextProps.cellValue,
      row: nextProps.rowValue,
      groupID: nextProps.rowValue.groupID,
      groupName: nextProps.rowValue.groupName,
      groupDesc: nextProps.rowValue.groupDesc,
      selectedMember: memberarray,
      groupLocksArrayList: lockarray,
    });
  }

  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
    //groups
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();
            const memberDetails = superAdminData.members;
            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;
              if (eachMemberEmail === auth.currentUser.email) {
                const superAdminID = superAdmin.key;
                this.setState({
                  isAdmin: eachMemberDetails.isAdmin,
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                  superAdminID: superAdminID,
                });
              }
            }
          });
        }
      });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      // customLog(item)
      // customLog(item.key)

      returnArr.push(item);
    });
    // customLog(returnArr)
    return returnArr;
  };

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  getBaseSerials = () => {
    const row = this.state.row || {};
    const serials = [];

    _.map(row.groupLocks, (lockData) => {
      if (lockData?.ip45SerialNumber) serials.push(lockData.ip45SerialNumber);
    });

    return serials;
  };

  fetchSharedLocksSerialsCount = async () => {
    const { superAdminID } = this.state;
    const groupID = this.state.groupID;

    if (!superAdminID || !auth.currentUser?.uid || !groupID) return 0;

    // 1) get all lockGroupManagement entries for this user
    const snap = await fire
      .database()
      .ref("lockGroupManagement")
      .child(superAdminID)
      .child(auth.currentUser.uid)
      .once("value");

    if (!snap.exists()) return 0;

    const sharedLockGroupIds = new Set();

    // 2) find lockGroupIds that are shared to THIS group
    snap.forEach((lockGroupSnap) => {
      const shared = lockGroupSnap.child("sharedInstances");
      if (!shared.exists()) return;

      shared.forEach((instSnap) => {
        const inst = instSnap.val() || {};
        if (inst.recipientType === "GROUP" && inst.recipientUID === groupID) {
          sharedLockGroupIds.add(lockGroupSnap.key);
        }
      });
    });

    // 3) collect serials from those lockGroupIds
    const sharedSerials = new Set();
    for (const lockGroupId of Array.from(sharedLockGroupIds)) {
      const locksSnap = await fire
        .database()
        .ref("lockGroupManagement")
        .child(superAdminID)
        .child(auth.currentUser.uid)
        .child(lockGroupId)
        .child("locks")
        .once("value");

      if (locksSnap.exists()) {
        locksSnap.forEach((c) => {
          const serial = c.val();
          if (serial) sharedSerials.add(serial);
        });
      }
    }

    // 4) remove serials that already exist in base group locks
    const baseSerials = new Set(this.getBaseSerials());
    let extraCount = 0;
    sharedSerials.forEach((s) => {
      if (!baseSerials.has(s)) extraCount += 1;
    });

    return extraCount;
  };

  handleGroupProfilePopupOpen = async () => {
    this.setState({ isLoading: true });

    try {
      // wait until superAdminID is ready
      if (!this.state.superAdminID) {
        await new Promise((resolve) => {
          const i = setInterval(() => {
            if (this.state.superAdminID) {
              clearInterval(i);
              resolve();
            }
          }, 50);
        });
      }

      // fetch shared locks count
      const extra = await this.fetchSharedLocksSerialsCount();

      // ✅ NOW open modal with correct data
      this.setState({
        sharedLocksCount: extra,
        showPopup: true,
        isLoading: false,
      });
    } catch (e) {
      console.error("fetchSharedLocksSerialsCount error:", e);

      // still open modal, but safely
      this.setState({
        sharedLocksCount: 0,
        showPopup: true,
        isLoading: false,
      });
    }
  };

  handleGroupProfilePopupClose() {
    this.setState({
      showPopup: false,
    });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        {/* <a onClick={this.handleGroupProfilePopupOpen} className="groupProfile">
          {this.state.groupName}
        </a> */}
        {/* <Button
          onClick={this.handleGroupProfilePopupOpen}
          // className="btn btn-info"
          // style={{ borderRadius: "50px" }}
          style={{ border: "none", fontSize: "1.5em", fontWeight: "bold" }}
        > */}
        {/* {localizationStrings.viewDetailsBtn} */}
        {/* {" "} */}
        <span
          onClick={
            !this.state.isLoading ? this.handleGroupProfilePopupOpen : undefined
          }
          style={{
            fontSize: "1.8em",
            cursor: this.state.isLoading ? "not-allowed" : "pointer",
            opacity: this.state.isLoading ? 0.5 : 1,
          }}
          data-notify="icon"
          className={
            this.state.isLoading ? "fa fa-spinner fa-spin" : "pe-7s-info"
          }
          id="detailsIcon"
        />
        {/* </Button> */}
        {/* //! Popup for Group Profile */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handleGroupProfilePopupClose}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.groupProfileHeader}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "40px 30px 60px 30px" }}>
            <div
              className="groupSummary"
              style={{
                textAlign: "center",
                display: "flex",
              }}
            >
              <div style={{ width: "50%" }}>
                <img
                  src={userIcon}
                  alt="user_image"
                  width="70px"
                  height="70px"
                />
                <h1 style={{ marginTop: "15px" }}>
                  {this.state.selectedMember.length}
                </h1>
                <h5 style={{ marginTop: "15px", fontSize: "1.3em" }}>
                  {localizationStrings.membersTitle}
                </h5>
              </div>
              <div style={{ width: "50%" }}>
                <img
                  src={lockIcon}
                  alt="lock_image"
                  width="70px"
                  height="70px"
                />
                <h1 style={{ marginTop: "15px" }}>
                  {this.state.groupLocksArrayList.length +
                    this.state.sharedLocksCount}
                </h1>
                <h5 style={{ marginTop: "15px", fontSize: "1.3em" }}>
                  {localizationStrings.locksTitle}
                </h5>
              </div>
            </div>
            <hr />
            <div
              className="groupDetailsContainer"
              style={{ display: "flex", padding: "20px 40px" }}
            >
              <div
                className="groupDetailsLabel"
                style={{ width: "50%", paddingRight: "30px" }}
              >
                <p>{localizationStrings.groupNameLabel}</p>
                <br />
                <p>{localizationStrings.groupDescriptionLabel}</p>
              </div>
              <div className="groupDetailsText" style={{ width: "50%" }}>
                <p>{this.state.groupName}</p>
                <br />
                <p>
                  {this.state.groupDesc !== "" ? this.state.groupDesc : "-"}
                </p>
              </div>
            </div>
            <hr />
            <div style={{ padding: "20px 40px" }}>
              <p style={{ fontSize: "1.2em", marginBottom: "15px" }}>
                {localizationStrings.groupMembersLabel}
              </p>
              <BootstrapTable
                data={this.state.selectedMember}
                pagination
                options={{
                  sizePerPage: 5,
                  hideSizePerPage: true,
                  noDataText: localizationStrings.noDataTitle,
                }}
              >
                <TableHeaderColumn
                  dataField="memberName"
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.nameHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="memberEmail"
                  isKey={true}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.emailHeader}
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default GroupProfile;
